<app-card [titleKey]="translationKey + 'cardTitle'">
  <div class="section-b-grid">
    <labeled-content [label]="'general.collectionTargetAmount'">
      <span class="data-labels">{{
        projectDetails().targetAmount | currencyFormat : projectDetails().currency
      }}</span>
    </labeled-content>
    <labeled-content [label]="translationKey + 'pastCollections'">
      <span class="data-labels">{{
        projectDetails().currentAmount
          | currencyFormat
          : projectDetails().currency
      }}</span>
    </labeled-content>
    <labeled-content [label]="translationKey + 'collectionEndDate'">
      <span class="data-labels">{{
        projectDetails().targetColletionEndDate | date : "yyyy.MM.dd"
      }}</span>
    </labeled-content>
    <labeled-content [label]="translationKey + 'minimumOffer'">
      <span class="data-labels">{{
        projectDetails().offerMinAmount
          | currencyFormat
          : projectDetails().currency
      }}</span>
    </labeled-content>
    <labeled-content [label]="translationKey + 'maximumOffer'">
      <span class="data-labels">{{
        projectDetails().offerMaxAmount
          | currencyFormat
          : projectDetails().currency
      }}</span>
    </labeled-content>
    <labeled-content [label]="translationKey + 'poFunds'">
      <span class="data-labels">{{
        projectDetails().ownerCapital
          | currencyFormat
          : projectDetails().currency
      }}</span>
    </labeled-content>
  </div>
  <app-info-label [label]="translationKey + 'infoLabel'" />
</app-card>
